// extracted by mini-css-extract-plugin
export default {"slider":"style_slider__qXxTd","categories_container":"style_categories_container__d0I5t","block":"style_block__b3ZGb"};